import type { Equipment } from "@/data/mockData";

const slugifyEquipmentName = (value: string) => String(value || "")
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/^-+|-+$/g, "");

const randomPrefix = () => Math.floor(10000 + Math.random() * 90000);

export const buildEquipmentLink = (equipment: Pick<Equipment, "id" | "title">) => {
  const slug = slugifyEquipmentName(equipment.title || "equipment");
  return `/equipment/${randomPrefix()}-${slug}?ref=${encodeURIComponent(equipment.id)}`;
};

export const resolveEquipmentFromRoute = (items: Equipment[], routeParam?: string, refParam?: string) => {
  if (!items.length) return null;

  const byRef = items.find((entry) => entry.id === refParam);
  if (byRef) return byRef;

  const byExactId = items.find((entry) => entry.id === routeParam);
  if (byExactId) return byExactId;

  const normalized = String(routeParam || "").trim().toLowerCase();
  const withoutPrefix = normalized.replace(/^\d+-/, "");
  const slug = withoutPrefix.replace(/-+$/, "");

  if (!slug) return null;
  return items.find((entry) => slugifyEquipmentName(entry.title) === slug) || null;
};
